export default function randomColor(nub) {
  const colors = ['#00a69b', '#c3d714', '#f8b61c', '#ae027e'];
  const temp = colors;
  const data = [];
  if (nub > 1) {
    for (let i = 0; i < nub; i += 1) {
      const c = Math.floor(Math.random() * (temp.length - i));
      data.push(temp[c]);
      temp[c] = temp[temp.length - i - 1];
    }
  } else {
    return temp[Math.floor(Math.random() * (temp.length - 1))];
  }

  return data;
}
